import React, { FC } from "react";

import { Avatar, AvatarType } from "./Avatar";
import { AvatarByWalletAccount } from "./AvatarByWalletAccount";

/**
 *
 * @param props accepting Array of Object, which containing src and alt
 * @returns
 */
export const StackedAvatarList: FC<{ avatars: AvatarType[] }> = (props) => {
  const { avatars } = props;

  return (
    <div className="flex -space-x-6">
      {avatars.map((el, idx) => {
        if (el.walletAccount) {
          return (
            <AvatarByWalletAccount
              key={idx}
              walletAccount={el.walletAccount}
              height="h-12"
              width="w-12"
            />
          );
        }
        return <Avatar key={idx} avatar={el} height="h-12" width="w-12" />;
      })}
    </div>
  );
};
